module.exports = __webpack_public_path__ + "static/headshot-ben-hughes.3ed41494.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/headshot-ben-hughes.jpg
// module id = 119
// module chunks = 35783957827783 152909308826437